import {BsTextareaResize, BsUiChecks, BsUiRadios} from "react-icons/bs"
import {MdShortText, MdTitle} from "react-icons/md"
import {FaAlignLeft, FaCalendar, FaFile, FaHeading, FaImage, FaSignature} from "react-icons/fa"
import {ImPageBreak} from "react-icons/im";

const ToolboxItems = [
    {id: "toolbox-title", label: "Title", Icon: FaHeading},
    {id: "toolbox-subtitle", label: "Sub-Title", Icon: MdTitle},
    {id: "toolbox-input", label: "Input", required: false, Icon: MdShortText, pdfWidth: 12, referenceId: ""},
    {id: "toolbox-textarea", label: "Text area", required: false, Icon: BsTextareaResize, referenceId: ""},
    {id: "toolbox-date", label: "Date", required: false, Icon: FaCalendar, pdfWidth: 12, referenceId: ""},
    {id: "toolbox-datetime", label: "DateTime", required: false, Icon: FaCalendar, pdfWidth: 12, referenceId: ""},
    {id: "toolbox-checkbox", label: "Checkbox", required: false, options: [], Icon: BsUiChecks, pdfWidth: 12},
    {id: "toolbox-radio", label: "Radio", required: false, options: [], Icon: BsUiRadios, pdfWidth: 12},
    {id: "toolbox-intext", label: "InText", Icon: FaAlignLeft},
    {id: "toolbox-file", label: "File", Icon: FaFile},
    {id: "toolbox-signature", label: "Signature", Icon: FaSignature},
    {id: "toolbox-agentSignature", label: "Agent", Icon: FaSignature},
    {id: "toolbox-pageBreak", label: "PageBreak", Icon: ImPageBreak},
    {id: "toolbox-image", label: "Image", Icon: FaImage, file: undefined},
]

export default ToolboxItems;